import { MaskImageComp } from '../ai-form/MaskImageComp'
import { PictureResolutionComp } from '../ai-form/PictureResolutionComp'
import { PictureSizeComp } from '../ai-form/PictureSizeComp'
import { PromptComp } from '../ai-form/PromptComp'
import { StyleDecorationComp } from '../ai-form/StyleDecorationComp'

export const MaskFormContent = () => {
  return (
    <>
      {/** 图片上传及涂抹 */}
      <MaskImageComp />

      {/* 画面描述 */}
      <PromptComp />

      {/* 画面大小和尺寸 */}
      <PictureSizeComp />
      <PictureResolutionComp />

      {/** 标签选择 */}
      <StyleDecorationComp />
    </>
  )
}
